<template lang="html">
  <div class="report-wrap">
    <report-summary :groups="getGroups" />

    <top-btns />

    <div class="reports-section" ref="reports">
      <div ref="pdfPrint" class="reports-wrap">
        <div class="grid-container reports-container">
          <report-group v-for="(g, i) in getGroups" :key="'g' + i" :group="g" />
        </div>
      </div>
    </div>

    <bottom-btns />
  </div>
</template>

<script>
import Summary from "@/views/Results/Summary";
import Group from "@/views/Results/Group";
import TopBtns from "@/views/Results/TopBtns";
import BottomBtns from "@/views/Results/BottomBtns";
import axios from "axios";

export default {
  name: "Report",
  components: {
    "report-summary": Summary,
    "report-group": Group,
    "top-btns": TopBtns,
    "bottom-btns": BottomBtns,
  },
  props: ["user"],
  data() {
    return {
      hubForm: {
        email: "",
        lastname: "",
        firstname: "",
        company: "",
        remix_report_data: "",
        hs_context: {},
      },
      form: this.$store.state.formData,
      content: this.$store.state.content,
    };
  },
  methods: {
    setUserData(fields) {
      fields.push({
        name: "email",
        value: this.user.email,
      });
      fields.push({
        name: "firstname",
        value: this.user.firstname,
      });
      fields.push({
        name: "lastname",
        value: this.user.lastname,
      });
      fields.push({
        name: "company",
        value: this.user.company,
      });
      return fields;
    },
    setSummaryScores(fields) {
      //console.log(fields);
      const groupData = {
        website: { hub: "website_score", total: 26 },
        inbound: { hub: "inbound_marketing_score", total: 30 },
        blog: { hub: "blog_score", total: 20 },
        seo: { hub: "seo_score", total: 22 },
        social: { hub: "social_media_score", total: 38 },
        outbound: { hub: "outbound_score", total: 16 },
        premium: { hub: "premium_content_score", total: 15 },
      };
      let setGroups = this.getSetGroups;
      let f = this.form;
      let groupScores = {};

      (groupScores.blog_score = 0),
        (groupScores.inbound_marketing_score = 0),
        (groupScores.outbound_score = 0),
        (groupScores.premium_content_score = 0),
        (groupScores.seo_score = 0),
        (groupScores.social_media_score = 0),
        (groupScores.website_score = 0);

      setGroups.forEach((key) => {
        for (let k in f) {
          if (f[k].group === key) {
            if (typeof groupScores[groupData[key].hub] != "undefined") {
              groupScores[groupData[key].hub] += f[k].score;
            }
          }
        }
      });

      for (let key in groupData) {
        let val = groupScores[groupData[key].hub];
        let tot = groupData[key].total;
        groupScores[groupData[key].hub] = Math.round((val / tot) * 100);
      }

      groupScores.remix_overall = this.getOverallScore(groupScores, groupData);

      groupScores.biztype =
        f["Company_Type"].value === "b2b_company" ? "B2B" : "B2C";

      let market_eff = f["Marketing_Effectiveness"].value;
      groupScores.marketing_efficiency = parseInt(
        market_eff[market_eff.length - 1]
      );

      const budgets = this.content.marketbudget.form.options;
      let budget = "";
      budgets.forEach((obj) => {
        if (f["Marketing_Budget"].value === obj.value) {
          budget = obj.label;
        }
      });
      groupScores.marketing_budget = budget;

      groupScores.remix_report_data = this.serializeReport();

      for (let key in groupScores) {
        if (typeof groupScores[key] != "undefined") {
          let field = groupScores[key];
          fields.push({
            name: key,
            value: field,
          });
        }
      }
      // console.log(fields);
      return fields;
    },
    getOverallScore(all, data) {
      let scores = [];
      for (let key in all) {
        scores.push(all[key]);
      }
      return Math.round(
        scores.reduce((a, b) => {
          return a + b;
        }) / scores.length
      );
    },
    serializeReport() {
      let serial = "";
      let f = this.form;
      for (let prop in f) {
        //console.log(f[prop]);
        serial += "q" + f[prop].id.toString(16) + "x" + f[prop].serial;
      }
      return serial;
    },
  },
  computed: {
    getGroups() {
      let groups = [];
      for (let v in this.content) {
        if (this.content[v].form.report) {
          groups.push(this.content[v].form.group);
        }
      }
      return Array.from(new Set(groups));
    },
    getSetGroups() {
      let groups = [];
      for (let v in this.form) {
        if (this.form[v].report) {
          groups.push(this.form[v].group);
        }
      }
      return Array.from(new Set(groups));
    },
  },
  created() {
    if (this.user) {
      const pid = "526959";
      const guid = "42c9437a-ffef-40cd-acb3-cb47439e1c54";
      let context = this.hubForm.hs_context;
      context.ipAddress = this.user.ip;
      context.pageUri = "https://marketing-remix.com/apps/marketing-remix/";
      context.pageName = "Marketing Remix";
      context.hutk = window.__hsUserToken;
      let fields = [];
      fields = this.setUserData(fields);

      this.hubForm.remix_report_data = this.serializeReport();

      fields = this.setSummaryScores(fields);

      let submittedAt = new Date();
      submittedAt = submittedAt.getTime();

      axios
        .post(
          "https://api.hsforms.com/submissions/v3/integration/submit/" +
            pid +
            "/" +
            guid,
          {
            submittedAt,
            fields,
            context,
            skipValidation: false,
          }
        )
        .then((resp) => {
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
        });

      this.$store.state["docDefinition"] = {
        content: [],
        defaultStyle: {
          font: "Roboto",
        },
        styles: {
          wmkLogo: {
            alignment: "center",
          },
          topHeader: {
            fontSize: 45,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [50, 5, 50, 10],
            lineHeight: 0.7,
          },
          header: {
            fontSize: 45,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [50, 25, 50, 10],
            lineHeight: 0.7,
          },
          headerScore: {
            fontSize: 35,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [0, 0, 0, 10],
          },
          tableHeader: {
            fontSize: 14,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [0, 0, 0, 0],
            lineHeight: 0.7,
          },
          tableScore: {
            fontSize: 20,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [0, 0, 0, 0],
          },
          score: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            color: "#F15A23",
            margin: [50, 0, 50, 16],
          },
          question: {
            fontSize: 20,
            alignment: "center",
            bold: true,
            color: "#00A6A6",
            margin: [50, 0, 50, 4],
          },
          answer: {
            fontSize: 17,
            alignment: "center",
            bold: true,
            color: "#ff7c01",
            margin: [50, 0, 50, 10],
          },
          response: {
            fontSize: 14,
            margin: [50, 0, 50, 20],
          },
          link: {
            fontSize: 20,
            alignment: "center",
            color: "white",
            bold: true,
            margin: [0, 40, 0, 0],
          },
          wmkLogoFooter: {
            alignment: "center",
            margin: [0, 0, 0, 5],
          },
          details: {
            fontSize: 10,
            alignment: "center",
          },
        },
        pageBreakBefore: function (
          currentNode,
          followingNodesOnPage,
          nodesOnNextPage,
          previousNodesOnPage
        ) {
          if (
            currentNode.headlineLevel === 1 &&
            followingNodesOnPage.length <= 3 &&
            nodesOnNextPage.length > 0
          ) {
            return true;
          } else if (
            currentNode.headlineLevel === 2 &&
            followingNodesOnPage.length <= 1 &&
            nodesOnNextPage.length > 0
          ) {
            return true;
          } else if (
            currentNode.headlineLevel === 3 &&
            followingNodesOnPage.length === 0 &&
            nodesOnNextPage.length > 0
          ) {
            return true;
          }
        },
      };
    } else {
      this.$store.state["docDefinition"] = {
        content: [],
      };
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(vm.form);
      if (Object.keys(vm.form).length) {
        next();
      } else {
        next("/apps/marketing-remix");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (Object.keys(this.form).length === 0) {
      next();
      return;
    }
    const answer = window.confirm(
      "Do you really want to leave? You will lose your REMIX report!"
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => {
      e.returnValue = "";
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";
@import "../assets/scss/mixins";

.report-wrap {
  @media only screen and (min-width: 40rem) {
    padding-top: gu(6);
    padding-bottom: gu(6);
  }

  @media only screen and (min-width: 64rem) {
    padding-top: gu(9);
    padding-bottom: gu(7);
  }
}

.reports-container {
  max-width: 80rem;
  background-color: $white;
  padding-top: gu(3);
  padding-bottom: gu(3);

  @media only screen and (min-width: 40rem) {
    padding-top: gu(7);
    padding-bottom: gu(7);
  }
}
</style>
